import EditProductQuantity from './EditProductQuantity';

export default EditProductQuantity;
